module.exports = __webpack_public_path__ + "img/album14_30.95351f49.jpg";